import { createSlice } from '@reduxjs/toolkit';
import { getLocalStorage } from '../Helper/helperFunctions';

const initialState = {
  user: JSON.parse(getLocalStorage("user")) || null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    clearUser(state) {
      state.user = null;
    },
  },
});

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
